import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  viewBox: "0 0 20 21",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, [...(_cache[0] || (_cache[0] = [
    _createElementVNode("g", { opacity: "0.4" }, [
      _createElementVNode("path", {
        d: "M14.4001 14.9004L18.0001 18.5003",
        stroke: "white",
        "stroke-width": "2",
        "stroke-linecap": "round",
        "stroke-linejoin": "round"
      }),
      _createElementVNode("path", {
        d: "M16.4001 9.69982C16.4001 5.72347 13.1766 2.5 9.20007 2.5C5.22358 2.5 2 5.72347 2 9.69982C2 13.6762 5.22358 16.8996 9.20007 16.8996C13.1766 16.8996 16.4001 13.6762 16.4001 9.69982Z",
        stroke: "white",
        "stroke-width": "2",
        "stroke-linejoin": "round"
      })
    ], -1)
  ]))]))
}
export default { render: render }